import React from 'react'

const ChannelDetail = () => {
  return (
    <div>ChannelDetails</div>
  )
}

export default ChannelDetail